// extracted by mini-css-extract-plugin
export default {"cautionBox":"o9-z"};